import React from 'react';
import { routes } from 'constants/config';
import useFetch from 'components/shared/hooks/useFetch';
import { Spinner } from 'ui';
import ModuleLoadFailure from './ModuleLoadFailure';

const CompletionPercentage = ({ lessonId, currentGroupId }) => {
  const { data, loading, error, runRequest } = useFetch(
    routes.LESSON_OVERVIEW.ASSIGNMENT_COMPLETION(lessonId, currentGroupId),
  );
  if (loading) return <Spinner />;
  if (error) {
    return <ModuleLoadFailure reload={runRequest} />;
  }
  const { completionPercentage } = data;
  return (
    <div className="d-f">
      <section className="Module EditableModule EditableModule-completionPercentage f-1">
        <h3 className="Module-heading SectionHeading">
          {t('lessons.completion_percentage')}
        </h3>
        <div className="d-f ai-c">
          <div className="LearnerReviews-ratioBar m-0">
            <div
              className="LearnerReviews-ratio LearnerReviews-ratio--positive"
              style={{ width: completionPercentage }}
            />
          </div>
          <span className="LearnerReviews ml-8">{completionPercentage}</span>
        </div>
      </section>
    </div>
  );
};

export default props => <CompletionPercentage {...props} />;
